import { ChangeDetectionStrategy, Component, input, output } from "@angular/core";
import { MatIconButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";

/**
 * Prev/next rotation control (0-based index / count) for use inside a `lib-floating-panel`
 * header via the `panelHeaderActions` projection slot. Hides itself when there's nothing to
 * rotate through, so callers never need to special-case a single-item list.
 */
@Component({
  selector: "lib-panel-rotate-control",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconButton, MatIcon],
  templateUrl: "./panel-rotate-control.component.html",
})
export class PanelRotateControlComponent {
  readonly index = input.required<number>();
  readonly count = input.required<number>();

  readonly previous = output<void>();
  readonly next = output<void>();
}
